import {SET_LISTINGS, SET_DESTINATIONS_LISTINGS} from '../actions/action-types';

export default function modules(state = {}, action) {
    switch (action.type) {
        case SET_LISTINGS:
            return {
                ...state,
                searchMessages: action.mapListingMessages,
            };
        case SET_DESTINATIONS_LISTINGS:
            return {
                ...state,
                destinations: state.destinations.map((destination) => ({
                    ...destination,
                    ...action.payload[destination.lbsId],
                })),
            };
        default:
            return state;
    }
}
